import { Trans, t } from '@lingui/macro'

import {
  Dialog,
  DialogContainer,
  DialogContent,
  DialogContextType,
  DialogHeading,
  DialogXButton,
} from 'src/components/Dialog'

import CloneCartForm from 'src/forms/CloneCartForm'
import { openFailureToast, openSuccessToast } from 'src/lib/toast'

type CloneCartDialogContainerProps = {
  cart: any
  onClose: () => void
}

const CloneCartDialogContainer: React.FC<CloneCartDialogContainerProps> = ({
  cart,
  onClose,
}) => (
  <Dialog initialOpen onClose={onClose}>
    <DialogContainer>
      <DialogXButton />
      <DialogHeading>
        <Trans>Clone cart</Trans>
      </DialogHeading>
      <DialogContent>
        {
          ((context: DialogContextType) => {
            const dismiss = () => context.setOpen(false)
            return (
              <CloneCartForm
                cart={cart}
                onSuccess={() => {
                  openSuccessToast(t`Cart cloned successfully`)
                  dismiss()
                }}
                onError={() => {
                  openFailureToast(t`Cart could not be cloned`)
                  dismiss()
                }}
                onCancel={dismiss}
              />
            )
          }) as any
        }
      </DialogContent>
    </DialogContainer>
  </Dialog>
)

export default CloneCartDialogContainer
